import { useQuery } from "@msuite/ui/query";
import { DataTable } from "@msuite/ui/table";
import { responseHandler } from "@msuite/ui/utils";
import { guardArray } from "@msuite/utils/array";
import type { ProjectCardWithInvoices } from "@msuite/utils/types";
import { useProjectsFilterController } from "@/components/projects";
import { client } from "@/hono";
import { useMembers } from "@/hooks/use-members";
import { useWorkspaces } from "@/hooks/use-workspaces";
import { ProjectsTableConfig } from "@/sites/projects/projects";
import { ProjectsMenu } from "@/sites/projects/projects/projects-menu";
import type { ContactPanelBaseProps } from "../types";

export function ContactProjects({ contactId }: ContactPanelBaseProps) {
	/** Hooks */

	/** Query */
	const { members } = useMembers();
	const { workspaces } = useWorkspaces();
	const { data, isLoading, queryKey, refetch } = useQuery({
		queryKey: ["projects", contactId],
		queryFn: async () => {
			const response = await client.projects.index.$get({
				query: { limit: "5000", state: "active", clientId: contactId },
			});
			const data = await responseHandler(response);
			return guardArray(data.projects) as ProjectCardWithInvoices[];
		},
	});
	const projectsFilter = useProjectsFilterController(data, {
		users: members,
		workspaces,
	});

	/** Render */
	return (
		<DataTable
			data={projectsFilter.filtered as Array<ProjectCardWithInvoices>}
			columns={ProjectsTableConfig}
			persistenceKey="projects-table"
			queryKey={queryKey}
			isLoading={isLoading}
			menu={
				<ProjectsMenu
					controller={projectsFilter}
					queryKey={queryKey}
					defaultValues={{ clientId: contactId }}
				/>
			}
			refetch={refetch}
		/>
	);
}
